import { render, staticRenderFns } from "./CreateConfiguration.vue?vue&type=template&id=bfcfebae&"
import script from "./CreateConfiguration.vue?vue&type=script&lang=ts&"
export * from "./CreateConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports